import ModalLayout, { DockPosition } from "components/ModalLayout";
import styles from "./styles.module.scss";
import CloseIcon from "assets/icons/close.svg?react";
import { useContext, useState } from "react";
import ModalsManagerContext from "contexts/ModalsManager";
import ClientsContext from "contexts/ClientsContext";
import Input from "components/Input";
import Button from "components/Button";
import clientService from "api/clientService";
import { useTranslation } from "react-i18next";
const AddAddressModal = () => {
  const { t } = useTranslation();
  const link = window.location.href;

  const clientId = link.split("/").at(-1);

  const { modals, setModals } = useContext(ModalsManagerContext);
  const { clients, setClients } = useContext(ClientsContext);
  const { mutate: updateClient } = clientService.useNewUpdateClient();

  const [street, setStreet] = useState("");
  const [zipCode, setZipCode] = useState("");
  const [city, setCity] = useState("");

  const closeModal = () => {
    setModals({ ...modals, hide: true });
  };

  const handleSave = () => {
    const address = { Address: street, ZipCode: zipCode, City: city };

    const object = {
      Type: "address",
      IsMain: false,
      Value: JSON.stringify(address),
    };

    const copy = [...clients];
    const client = copy.find((c) => c.Id.toString() === clientId);
    if (!client) return;
    client.Data.push(object);

    updateClient(client, {});

    setClients(copy);
    setModals({ ...modals, hide: true });
  };

  return (
    <ModalLayout
      dock={DockPosition.DISABLED}
      off={true}
      customX={8}
      customY={0}
      ignore
      isAnimation
      fullHeight={true}
      name="addAddress"
    >
      <div className={styles.wrapper}>
        <div className={styles.title}>
          {t("modals.newAddress")}
          <CloseIcon
            onClick={() => {
              closeModal();
            }}
            className={styles.closeIcon}
          />
        </div>
        <div className={styles.content}>
          <Input
            value={street}
            onChange={(t) => setStreet(t)}
            placeholder=""
            label={t("forms.street")}
          />
          <div className={styles.form}>
            <div className={styles.group}>
              <Input
                value={zipCode}
                onChange={(t) => setZipCode(t)}
                placeholder=""
                isCode
                label={t("forms.zipCode")}
              />
              <Input
                value={city}
                onChange={(t) => setCity(t)}
                placeholder=""
                label={t("forms.city")}
              />
            </div>
          </div>
        </div>
        <div className={styles.buttons}>
          <Button
            disabled={!zipCode.length || !city.length || !city.length}
            onClick={handleSave}
            text={t("common.add")}
          />
        </div>
      </div>
    </ModalLayout>
  );
};

export default AddAddressModal;
